import React from 'react';

/**
 * BulletList renders an array of bullet items with the configured bullet style and gap.
 */
export const BulletList = ({ bullets = [], style = {} }) => {
  if (!bullets || bullets.length === 0) return null;
  return (
    <ul 
      className="block-bullet-list"
      style={{ 
        margin: '4px 0 0 0', 
        paddingLeft: '12px', 
        listStyleType: 'var(--bullet-style, disc)',
        ...style 
      }}
    >
      {bullets.map((b, idx) => {
        const text = typeof b === 'string' ? b : (b.text || b.value || JSON.stringify(b));
        return (
          <li 
            key={idx} 
            style={{ 
              fontSize: 'var(--font-size-bullet, 8.8pt)', 
              lineHeight: 'var(--line-height-bullet, 1.35)',
              color: 'var(--color-text-main)',
              marginBottom: 'var(--spacing-bullet-gap, 4px)'
            }}
          >
            {text}
          </li>
        );
      })}
    </ul>
  );
};
export default BulletList;
